<template>
  <div>
    <b-card no-body class="bdr-tabs">
      <b-tabs card>
        <b-tab title="Сводная" active style="padding-top: 0; padding-bottom: 0;">
          <b-card-text>
            <CompetitorsSupplies />
          </b-card-text>
      </b-tab>
      <b-tab title="Таможенные представители">
        <b-card-text>
            <!-- <div><h5>Таможенные представители</h5></div> -->
            <CompetitorsTable />
          </b-card-text>
        </b-tab>
      </b-tabs>
    </b-card>    
  </div>
</template>

<script>
import CompetitorsTable from '@components/competitors/CompetitorsTable';
import CompetitorsSupplies from '@components/competitors/CompetitorsSupplies';

export default {
  name: "CompetitorPage",

  components: {
    CompetitorsTable,
    CompetitorsSupplies
  }
};
</script>